export default __webpack_public_path__ + "static/media/Pixentro2.9c2d9d7f.png";